
   <template>
  <v-card class="transparent elevation-0 mb-4 ml-2">
    <div class="text-xs-center">
      <v-dialog
        width="500"
        persistent
        v-model="wrongInput"
      >
        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title
          >
           Wrong input
          </v-card-title>
          <v-card-text>
            The input of the group size is wrong at "<i>{{wrongEvent}}</i>".
            <br>
            The max input is "<i>{{_tripForm.groupSize}}</i>"
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              @click="wrongInput = false"
            >
              {{$translate('CLOSE')}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout pb-4 row justify-center>
        <v-flex xs1>
          <v-layout row>
            <v-flex d-flex xs12>
              <v-card flat>
                <v-card-text></v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs6 class="px0">
          <h1>{{_tripForm.name}}</h1>
          <v-expansion-panel>
            <v-expansion-panel-content
              v-for="(item, index) in activities"
              v-if="item.Name != 'Start' && item.Name != 'End'"
              :key="index"
            >
              <template v-slot:header>
                <v-avatar size="35" class="avatarOfYourTrip" v-on="on">
                  <img v-if="picture !== undefined && picture != ''" :aspect-ratio="14/9" :src="picture" />
                  <img
                    v-else
                    src="https://cdn3.iconfinder.com/data/icons/abstract-1/512/no_image-512.png"
                  >
                </v-avatar>
                <div>{{item.Name}}</div>
              </template>
              <v-layout align-center justify-end row pr-5>
                <h3 class="addActivity">Add activities </h3>
                <v-icon large color="primary" @click="addActivityToYourDay(item)">add_circle</v-icon>
              </v-layout>
              <v-card v-for="(innerItem, innerIndex) in item.Children"
                      :key="innerIndex">
                <p>{{innerItem.Name}}</p>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-layout mt-5 row justify-space-around>
            <v-btn
              round
              class="text-capitalize"
              color="secondary"
              @click="goBack"
            >{{$translate('BACK')}}</v-btn>
            <v-btn
              v-if="activities.length != 0"
              round
              class="text-capitalize"
              color="primary"
              @click="saveWishlist()"
            >{{$translate('NEXT')}}</v-btn>
          </v-layout>
        </v-flex>

        <v-dialog v-model="eventDetailDialog" max-width="680" persistent>
          <v-card>
            <v-card-title
              :style="getFontProperty()"
              class="eventDetailName headline"
            >{{eventDetail.Name}}</v-card-title>
            <v-card-text>
              <img class="photoEvent" :src="this.eventDetail.Picture" />
              <br />
              <h3
                :style="getFontProperty()"
                class="eventDetailDate"
              >{{subEventStartTime}} - {{subEventEndTime}}</h3>
              <h3 class="eventDetailText" :style="getFontProperty()">{{eventDetail.Description}}</h3>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                round
                class="text-capitalize"
                color="primary"
                @click="eventDetailDialog = false"
              >{{$translate('CLOSE')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="errorDialog" max-width="290" persistent>
          <v-card>
            <v-card-title class="headline">{{$translate('ERROR')}}</v-card-title>
            <v-card-text>
              <p>{{$translate('LINDA_FILL_REQUIRED')}}</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                round
                class="text-capitalize"
                color="primary"
                @click="errorDialog = false"
              >{{$translate('NEXT')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-form>
    <v-dialog v-model="wrongTimeInput" max-width="320" persistent content-class="dialog_class">
      <v-card>
        <v-card-title class="headline">{{$translate('ERROR')}}</v-card-title>
        <v-card-text>
          <h3>
            {{$translate('NO_VALID_TIME_INPUT')}}
            <br />
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            round
            @click="wrongTimeInput= false"
          >{{$translate('CANCEL')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import appConfig from "../../config/app_config.js";
import * as dssRequest from "../api/dssRequest";
import { mapGetters } from "vuex";
import BaseObject from "../objects/BaseObject";
import BaseComponent from "./base/BaseComponent.vue";
import { ui_helpers } from "../shared/ui_helpers.js";
import Sortable from "sortablejs";

export default {
  extends: BaseComponent,
  mixins: [ui_helpers],

  name: "CustomerSelectionWishlist",
  props: {},

  computed: {
    ...mapGetters({
      _webStep: "getWebStepId",
      _tripForm: "getTripForm"
    })
  },

  watch: {
    activities: {
      handler(data) {
        this.activities.forEach(function(item, index, array) {
          item.orderNr = index + 1;
        });
        this.sortActivities;
      },
      deep: true
    }
  },

  data: () => ({
    picture: '',
    expand: false,
    wrongEvent: '',
    wrongInput: false,
    wrongTimeInput: false,
    arrivalPicker: false,
    departurePicker: false,
    subEventStartTime: "",
    subEventEndTime: "",
    errorDialog: false,
    valid: true,
    textRule: [v => !!v || "Field is required"],
    numberRule: [v => (v && v > 0) || "The group size can not be bigger 0 or less" ],
    eventDetail: {},
    eventDetailDialog: false,
    activitiesOrder: [],
    typesOfTrans: [],

    headers: [
      { text: "Activity", value: "name", sortable: false },
      { text: "Group size", value: "groupSize", sortable: false },
      { text: "", value: "", sortable: false }
    ],

    activities: []
  }),
  mounted() {
    this.getFullTrip()
    Object.size = function(obj) {
      var size = 0,
        key;
      for (key in obj) {
        if (obj.hasOwnProperty(key)) size++;
      }
      return size;
    };

    this._tripForm.chosenTheme = this.$store.getters.getTripFormChosenTheme;

    const self = this;

    this.activities.forEach(function(item, index, array) {
      if (!item.groupSize) {
        item.groupSize = Number(self._tripForm.groupSize);
      }
      self.activitiesOrder.push(item.EventId);
    });
  },

  directives: {
    sortableTable: {
      bind(el, binding, vnode) {
        let sortableElement = el.getElementsByTagName("tbody")[0];
        const options = {
          animation: 150,
          onUpdate: function(event) {
            vnode.child.$emit("sorted", event);
          }
        };
        Sortable.create(sortableElement, options);
      }
    }
  },

  methods: {
    getFullTrip() {
      const payload = {
        Runtime: true,
        TripId: this._tripForm.tripId,
        UserId: this.$store.getters["auth/userName"],
        AccountId: this.$store.getters.getCurrentAccountId
      };
      dssRequest.doRequest(
        response => {
          console.log("The generic call getFullTrip was successful", response);
          this.picture = response.data.Picture
          this.activities = response.data.Activities;
        },
        error => {
          console.log("The generic call getFullTrip was not successful", error);
        },
        "getFullTrip",
        this.$store.getters["auth/userName"],
        payload
      );
    },
    addActivityToYourDay(item){
      this.$store.commit("setWebStepId", this.$store.getters.getWebStepId + 1);
      this.$store.commit('setEventData', item)

    },
    saveOrder({ oldIndex, newIndex }) {
      const movedId = this.activitiesOrder.splice(oldIndex, 1)[0];
      this.activitiesOrder.splice(newIndex, 0, movedId);
    },

    sortActivities() {
      this.activities = this.activities.sort((a, b) => {
        return a.orderNr - b.orderNr;
      });
    },

    saveWishlist() {
      let wrongInput = false;
      this.activities.forEach(e => {
        if (e.groupSize > Number(this._tripForm.groupSize)) {
          this.wrongEvent = e.Name
          wrongInput = true;
        }
      })
      if (wrongInput) {
        this.wrongInput = true
        return;
      } else {
        this._tripForm.activities = [];
      this._tripForm.wishList = this.activities;

      const self = this;

      this._tripForm.wishList.sort(function(a, b) {
        return (
          self.activitiesOrder.indexOf(a.EventId) -
          self.activitiesOrder.indexOf(b.EventId)
        );
      });


      this.$emit("saveWishlist");
      }
    },

    getEventDetails(item) {
      const payload = {
        EventId: Number(item),
        LanguageTagId: this.$store.getters.getUserLanguage
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call getEventDetails was successful",
            response
          );
          this.eventDetailDialog = true;
          this.eventDetail = response.data;
          this.getSubEventTime(item);
        },
        error => {
          console.log(
            "The generic call getEventDetails was not successful",
            error
          );
          this.eventDetail = error.data;
        },
        "getEventDetailsV2",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    deleteTrip() {
        const payload = {
          Runtime: true,
          TripId: this._tripForm.tripId,
          FunctionId: "EventFunctionLibrary::deleteTrip()"
        };
        dssRequest.doRequest(
          response => {
            console.log("The call for deleteTrip was successful", response);
          },
          error => {
            console.log("The call for deleteTrip was not successful ", error);
          },
          "deleteTrip",
          this.$store.getters["auth/userName"],
          payload
        );
    },
    goBack() {
      this.deleteTrip();
      this.$store.commit("setWebStepId", this.$store.getters.getWebStepId - 1);
    }
  }
};
</script>
<style>
.photoEvent {
  margin-left: 3em !important;
  max-width: 40em;
  max-height: 40em;
}

.eventDetailText {
  margin-top: 2em !important;
  margin-left: 2.7em !important;
  margin-right: 2em !important;
  padding-bottom: 3em !important;
}

.layoutTest {
  margin-top: -2em !important;
}

.eventDetailName {
  padding-top: 2em !important;
  margin-left: 1.8em !important;
}
.eventDetailDate {
  margin-left: 2.8em;
}

.px0 {
  padding-left: 0.1em !important;
  padding-right: 0 !important;
}

.noPadding {
  padding: 0 !important;
  margin: 0 !important;
}
.rowNumber {
  text-align: center;
}

.rowNumberCard {
  height: 69px;
}

.p1 {
  padding-left: 1em !important;
  padding-right: 1em !important;
}

.noInput input[type="number"] {
  -moz-appearance: textfield;
  text-align: center;
}
.noInput input::-webkit-outer-spin-button,
.noInput input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.v-input__slot {
  align-items: center;
  justify-content: center;
}

.dot {
  font-size: 16px;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  justify-content: center;
  display: inline-flex;
  align-items: center;
  color: white;
}
  .addActivity {
    margin: 0 !important;
  }
.avatarOfYourTrip{
  margin: 1em 1em;
  max-width: 48px;
}
</style>
